import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row';
import { useLocation } from "react-router-dom";
import './blc_footer.css';
import Blc_footerOne from './Blc_footerOne';
import Blc_FooterTwo from './Blc_FooterTwo';
import { BsFillCaretUpFill } from 'react-icons/bs';
import { bottomTotop, useBlcNavScroll } from '../../Blc_Business/BlcHomeLandingPage/HomeWindowThree';
import Button from '@restart/ui/esm/Button';
import Blc_FooterTwoCopy from './Blc_FooterTwo_copy';
import MediaQuery from "react-responsive";


const BlcFooter = (props) => {
    // current page path 
    const pageLoc = useLocation().pathname;

    return (
        <>
            <MediaQuery maxWidth={576}>
                <Container fluid>
                    {
                        pageLoc === '/locations' ? <Row className="fRowone d-none">
                            <Col className="fColOne">
                                <Blc_footerOne val={props.valFooter} />
                            </Col>
                        </Row>
                            : <Row className="fRowone">
                                <Col className="fColOne">
                                    <Blc_footerOne val={props.valFooter} />
                                </Col>
                            </Row>
                    }

                    <Row className="frowDown">
                        <Col>
                            {/* <Blc_FooterTwo val ={props.valFooter}/> */}
                            <Blc_FooterTwoCopy val={props.valFooter} />
                        </Col>
                    </Row>
                </Container>
            </MediaQuery>
            <MediaQuery minWidth={577}>
                <Container fluid>
                    <Row className="fRowone">
                        <Col className="fColOne">
                            <Blc_footerOne val={props.valFooter} />
                        </Col>
                    </Row>
                    <Row className="frowDown">
                        <Col>
                            {/* <Blc_FooterTwo val ={props.valFooter}/> */}
                            <Blc_FooterTwoCopy val={props.valFooter} />
                        </Col>
                    </Row>
                </Container>
            </MediaQuery>

        </>
    )
}

export default BlcFooter;